export function formatWhen(order) {
  if (!order || typeof order !== "object") return "";

  const pick =
    (order.pickupWindow && typeof order.pickupWindow === "object" ? order.pickupWindow : null) ||
    (order.meta && order.meta.pickupWindow && typeof order.meta.pickupWindow === "object" ? order.meta.pickupWindow : null) ||
    (order.routeMeta && order.routeMeta.pickupWindow && typeof order.routeMeta.pickupWindow === "object" ? order.routeMeta.pickupWindow : null);

  if (pick) {
    let d = String(pick.date || "").trim();
    const f = String(pick.from || "").trim();
    const t = String(pick.to || "").trim();

    // normalize YYYY-MM-DD -> DD.MM.YYYY
    if (/^\d{4}-\d{2}-\d{2}$/.test(d)) d = d.split("-").reverse().join(".");

    const dash = (f && t) ? "–" : "";
    const time = (f || t) ? `${f}${dash}${t}` : "";
    return [d, time].filter(Boolean).join(" ").trim();
  }

  return "";
}
